import PropTypes from 'prop-types';
import React from 'react';

import DefaultArrows from './components/arrows';
import DefaultDots from './components/dots';
import { Slide, SlideList, Track, Wrapper } from './components/styled';

const MOBILE_BREAKPOINT = 640;
const SPEED = 1.5;
const AUTOPLAY_SPEED = 5000;
const AUTOPLAY_DELAY = 3000;
const slidesToShow_DEFAULT = 1;

/**
* @deprecated Use @r1-frontend/ui-react/components/NukaCarousel
* */
class Carousel extends React.Component {
    constructor(props) {
        super(props);
        const { initialSlide, slidesToShow } = props;
        this.state = {
            _initialSlide: initialSlide,
            initialSlide: Math.max(initialSlide, 0),
            slidesToShow: parseInt(slidesToShow),
            slideScale: 100 / parseInt(slidesToShow),
            isSlider: this.getSlidesCount() > slidesToShow,
            keyDirection: props.vertical ? 'Y' : 'X',
            keyScale: props.vertical ? 'height' : 'width',
        };
        this.deltaX = null;
        this.deltaY = null;
        this.touchMoveYCoords = [];
        this.touchStartX = null;
        this.touchStartY = null;
        this.startX = null;
        this.startTransformX = null;

        this.sliderTrackRef = React.createRef();
        this.slideListRef = React.createRef();
    }

    componentDidMount() {
        this.countSlidesToShow();
        if (window) {
            window.addEventListener('resize', this.countSlidesToShow);
        }
        const { autoplay, autoplayDelay } = this.props;
        if (autoplay) {
            setTimeout(() => {
                this.startAutoplay();
            }, autoplayDelay);
        }
    }

    componentDidUpdate(prevProps) {
        const { initialSlide: initialSlideProp, slidesToShow: slidesToShowProps, infinite, vertical, children } = this.props;
        const { initialSlide, initialRenderSlide, slidesToShow, isSlider } = this.state;

        // если поменялось slidesToShow - пересчитать характеристики слайдера
        if (parseInt(prevProps.slidesToShow) !== parseInt(slidesToShowProps)) {
            this.countSlidesToShow();
        }

        // если поменялось initialSlide - переключить на нужный слайд
        if (prevProps.initialSlide !== initialSlideProp) {
            this.swipeTo(initialSlideProp);
        }

        // если поменялось vertical - поменять ключи направления
        if (prevProps.vertical !== vertical) {
            this.setState({
                keyDirection: vertical ? 'Y' : 'X',
                keyScale: vertical ? 'height' : 'width',
            });
        }

        // если изменилось количество слайдов
        if (prevProps.children !== children) {
            const isNowSlider = this.getSlidesCount() > slidesToShow;
            this.setState({
                isSlider: isNowSlider,
            }, () => {
                !isNowSlider && this.swipeTo(0);
            });
        }

        // для бесконечного слайдера после перехода через границу - переключить на нужный слайд
        const isMainSlides = initialRenderSlide >= slidesToShow && initialRenderSlide < slidesToShow + this.getSlidesCount();
        if (infinite && !isMainSlides && isSlider) {
            setTimeout(() => this.swipeTo(initialSlide), 400);
        }
    }

    componentWillUnmount() {
        if (window) {
            window.removeEventListener('resize', this.countSlidesToShow);
        }
        this.stopAutoplay();
    }

    getSlidesCount = () => {
        const { children } = this.props;
        return Array.isArray(children) ? children.length : 1;
    };

    getMaxSlideIndex = () => {
        const { slidesToShow } = this.state;
        return Math.max(0, this.getSlidesCount() - slidesToShow);
    };

    getMaxRenderIndex = () => {
        const { infinite } = this.props;
        const { slidesToShow } = this.state;
        const childrenCount = this.getSlidesCount();
        // т.к. для бесконечного слайдера рендерятся дополнительные слайды с обеих сторон
        const actualSlidesCount = infinite ? childrenCount + 2 * slidesToShow : childrenCount;
        return Math.max(0, actualSlidesCount - slidesToShow);
    };

    countSlidesToShow = () => {
        const { responsive, slidesToShow: slidesToShowProp, infinite } = this.props;
        const { initialSlide, slidesToShow: currentSlidesToShow } = this.state;
        let nextSlidesToShow = slidesToShow_DEFAULT;

        const defaultResponsive = [{
            width: MOBILE_BREAKPOINT,
            slidesToShow: +slidesToShowProp,
        }];
        const breakpoints = responsive ? responsive.sort((a, b) => a.width - b.width) : defaultResponsive;
        breakpoints.forEach(breakpoint => {
            if (window.innerWidth > breakpoint.width) {
                nextSlidesToShow = breakpoint.slidesToShow;
            }
        });

        const isSlider = this.getSlidesCount() > nextSlidesToShow;
        if (infinite || currentSlidesToShow !== nextSlidesToShow) {
            this.setState({
                slidesToShow: nextSlidesToShow,
                slideScale: 100 / nextSlidesToShow,
                isSlider: isSlider,
            }, () => {
                isSlider && this.swipeTo(initialSlide, true);
            });
        }
    };

    startAutoplay = () => {
        const { autoplaySpeed } = this.props;
        clearInterval(this.autoplayLoop);
        this.autoplayLoop = setInterval(() => {
            const { initialSlide } = this.state;
            this.swipeTo(initialSlide + 1, true);
        }, autoplaySpeed);
    };

    stopAutoplay = () => {
        clearInterval(this.autoplayLoop);
    };

    // eslint-disable-next-line sonarjs/cognitive-complexity
    swipeTo = (slide, isAuto) => {
        const { _initialSlide, initialSlide, initialRenderSlide, slideScale, slidesToShow, isSlider } = this.state;
        const { infinite, scrollByShow } = this.props;
        if (isAuto !== true && _initialSlide !== slide) {
            this.stopAutoplay();
        }

        const maxSlideIndex = this.getMaxSlideIndex();
        const maxRenderIndex = this.getMaxRenderIndex();

        let nextSlide = slide;
        let nextRenderSlide;

        if (scrollByShow) {
            if (nextSlide > initialSlide) {
                if (initialSlide < maxSlideIndex && nextSlide > maxSlideIndex) {
                    nextSlide = maxSlideIndex;
                }
            } else if (nextSlide < 0 && initialSlide > 0) {
                nextSlide = 0;
            }
        }


        if (infinite && isSlider) {
            // т.к. индексы смещаются на slidesToShow
            nextRenderSlide = nextSlide + slidesToShow;
            if (nextSlide < 0) {
                nextSlide = maxSlideIndex;
                nextRenderSlide = 0;
            }
            if (nextSlide > maxSlideIndex) {
                nextSlide = 0;
                nextRenderSlide = maxRenderIndex;
            }
        } else {
            nextSlide = slide < 0 ? 0 : Math.min(slide, maxSlideIndex);
            nextRenderSlide = nextSlide;
        }

        const slideIsChanged = nextSlide !== initialSlide;

        this.transform(-nextRenderSlide * slideScale, slideIsChanged);
        if (slideIsChanged || nextRenderSlide !== initialRenderSlide) {
            this.onSlideChange(nextSlide, nextRenderSlide);
        }
    };

    onSlideChange = (slide, renderSlide) => {
        this.setState({
            initialSlide: slide,
            initialRenderSlide: renderSlide,
        });
        const { changeCallback } = this.props;
        if ('function' === typeof changeCallback) {
            changeCallback(slide);
        }
    };

    transform = (value, withTransition, grabbingCursor) => {
        const sliderRef = this.slideListRef.current;
        if (sliderRef) {
            sliderRef.style.transform = `translate${this.state.keyDirection}(${value}%)`;
            sliderRef.style.transition = withTransition ? 'transform 0.4s ease-in-out' : 'none';
            sliderRef.style.cursor = grabbingCursor ? 'grabbing' : 'grab';
        } else {
            this.stopAutoplay();
        }
    };

    move = (event, startX, startTransform) => {
        const { vertical } = this.props;
        const { slideScale } = this.state;
        const xCoord = event.type === 'touchmove'
            ? event.touches[0][`client${this.state.keyDirection}`]
            : event[`page${this.state.keyDirection}`];
        const walk = xCoord - startX;
        const sliderRef = this.slideListRef.current;

        const trackScale = sliderRef[vertical ? 'clientHeight' : 'clientWidth'];
        // вычисляем в процентах насколько надо сместить слайдер (начиная с 0)
        let transform = startTransform + SPEED * walk / trackScale * 100;

        const maxOffset = -this.getMaxRenderIndex() * slideScale;
        transform = transform > 0 ? 0 : Math.max(transform, maxOffset);

        this.transform(transform, false, true);

        if (sliderRef) {
            sliderRef.style.pointerEvents = 'none';
        }
    };

    // отслеживаю направление свайпа на мобилках /или других сенсорных дисплеях/
    moveDirection = (e) => {
        if (this.touchStartX === null) {
            return;
        }
        const y = e.touches ? e.touches[0].clientY : e.clientY;
        const x = e.touches ? e.touches[0].clientX : e.clientX;
        // для объектов карусели, находящихся сильно ниже в window, параметр this.touchStartY для не тач-скрина будет слишком большим,
        // поэтому нужна поправка на прокрутку окна.
        const scrolledWindowCorrectionY = e.touches ? 0 : window.scrollY;

        this.touchMoveYCoords.push(y);

        // в массиве остаются два элемента события touchmove - предыдущий [0] и текущий [1]
        this.touchMoveYCoords.length === 3 && this.touchMoveYCoords.splice(0, 1);
        // отслеживаю разницу между двумя точками touchmove:
        // 1. для вычисления направления свайпа по Y ("+" - свайп вверх / "-" - свайп вниз);
        // 2. для вычисления "скорости" свайпа - чем больше разница между точками, тем быстрее происходит свайп.

        this.deltaX = this.touchStartX - x;
        this.deltaY = this.touchStartY - scrolledWindowCorrectionY - y;

        if (this.props.vertical || (Math.abs(this.deltaX) > Math.abs(this.deltaY))) {
            this.move(e, this.startX, this.startTransformX);
        }
    };

    startDrag = (event) => {
        this.startX = event.type === 'touchstart'
            ? event.touches[0][`client${this.state.keyDirection}`]
            : event[`page${this.state.keyDirection}`];
        this.startTransformX = parseInt(
            (this.slideListRef.current.style.transform || '0')
                .replace(`translate${this.state.keyDirection}(`, ''),
        );

        this.touchStartX = event.type === 'touchstart' ? event.touches[0].clientX : event.pageX;
        this.touchStartY = event.type === 'touchstart' ? event.touches[0].clientY : event.pageY;

        const ref = this.sliderTrackRef.current;
        ref.onmousemove = this.moveDirection;
    };

    endDrag = () => {
        if (this.touchStartX === null) {
            return;
        }

        const ref = this.sliderTrackRef.current;


        const { infinite } = this.props;
        const { slideScale, slidesToShow, isSlider } = this.state;
        const endTransform = Math.abs(parseInt(
            (this.slideListRef.current.style.transform || '0')
                .replace(`translate${this.state.keyDirection}(`, ''),
        ));
        let currentSlideIndex = Math.abs(parseInt(endTransform / slideScale));
        const slideOffset = endTransform - slideScale * currentSlideIndex;
        // если сместили слайд больше, чем на половину, то листнуть на него
        if (Math.abs(slideOffset) > slideScale / 2) {
            currentSlideIndex++;
        }
        // учитываем, что у бесконечнего слайдера рендерятся по slidesToShow доп. слайдов на границах
        if (infinite && isSlider) {
            currentSlideIndex -= slidesToShow;
        }
        this.swipeTo(currentSlideIndex);
        ref.onmousemove = null;
        this.touchStartX = null;
        this.touchStartY = null;
        this.startX = null;
        this.startTransformX = null;

        this.touchMoveYCoords.length = 0; // "обнуляю" массив Y-координат touchmove

        const sliderRef = this.slideListRef.current;
        if (sliderRef) {
            sliderRef.style.pointerEvents = 'initial';
        }
    };

    // eslint-disable-next-line sonarjs/cognitive-complexity
    render() {
        const {
            showArrows,
            arrows: Arrows,
            showDots,
            dots: Dots,
            infinite,
            align,
            children,
            visibleCardWidth,
            vertical,
            overwriteStyles = {},
            arrowsConfig,
            showTransparent,
            scrollByShow,
            hideArrow,
            ...rest
        } = this.props;
        const { isSlider, slidesToShow, initialSlide, slideScale } = this.state;

        const childArray = Array.isArray(children) ? children : [children];
        const slidesCount = childArray.length;

        const slides = childArray.map((child, index) => {
            const firstSlideNum = initialSlide + 1;
            const lastSlideNum = initialSlide + slidesToShow;
            const currSlideNum = index + 1;
            const isTransparent = showTransparent && (currSlideNum < firstSlideNum || currSlideNum > lastSlideNum);

            return (
                <Slide
                    customStyles={overwriteStyles.slide}
                    key={index}
                    scale={slideScale}
                    vertical={vertical}
                    isTransparent={isTransparent}
                >
                    {child}
                </Slide>
            );
        });

        const controls = [];
        let dragNDropEvents = {};

        if (isSlider) {
            // добавляем drag'n'drop
            dragNDropEvents = {
                onMouseDown: this.startDrag,
                onTouchStart: this.startDrag,
                onMouseUp: this.endDrag,
                onTouchEnd: this.endDrag,
                onMouseLeave: this.endDrag,
                onTouchCancel: this.endDrag,
            };
            // добавляем зацикливание
            if (infinite) {
                // последние slidesToShow слайдов дублируем в начало
                for (let i = slidesCount - 1; i >= slidesCount - slidesToShow; i--) {
                    slides.unshift(
                        <Slide
                            customStyles={overwriteStyles.slide}
                            key={'before' + i}
                            scale={slideScale}
                            vertical={vertical}
                            isTransparent={showTransparent}
                        >{childArray[i]}</Slide>,
                    );
                }
                // первые slidesToShow слайдов дублируем в конец
                for (let i = 0; i < slidesToShow; i++) {
                    slides.push(
                        <Slide
                            customStyles={overwriteStyles.slide}
                            key={'after' + i}
                            scale={slideScale}
                            vertical={vertical}
                            isTransparent={showTransparent}
                        >{childArray[i]}</Slide>,
                    );
                }
            }
            // добавляем контролы
            if (showArrows) {
                const hideLeftArrow = hideArrow && initialSlide === 0;
                const hideRightArrow = hideArrow && initialSlide + slidesToShow === slidesCount;
                const swipeCount = scrollByShow ? slidesToShow : 1;

                controls.push(<Arrows
                    vertical={vertical}
                    key='arrows'
                    visibleCardWidth={visibleCardWidth}
                    swipeLeft={() => this.swipeTo(initialSlide - swipeCount)}
                    swipeRight={() => this.swipeTo(initialSlide + swipeCount)}
                    hideLeftArrow={hideLeftArrow}
                    hideRightArrow={hideRightArrow}
                    config={arrowsConfig}
                />);
            }
            if (showDots) {
                controls.push(
                    <Dots
                        key='dots'
                        vertical={vertical}
                        active={initialSlide}
                        count={this.getMaxSlideIndex()}
                        onClick={this.swipeTo}
                        slidesToShow={slidesToShow}
                    />,
                );
            }
        }

        return (
            <Wrapper {...rest}>
                <Track
                    customStyles={overwriteStyles.track}
                    visibleCardWidth={visibleCardWidth}
                    showTransparent={showTransparent}
                    ref={this.sliderTrackRef}
                    {...dragNDropEvents}
                    onDragStart={(e) => e.preventDefault()}
                >
                    <SlideList
                        ref={this.slideListRef}
                        isSlider={isSlider}
                        align={align}
                        vertical={vertical}
                        onTouchMove={this.moveDirection}
                    >
                        {slides}
                    </SlideList>
                </Track>
                {controls}
            </Wrapper>
        );
    }
}

Carousel.propTypes = {
    children: PropTypes.node.isRequired,
    slidesToShow: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    responsive: PropTypes.arrayOf(PropTypes.shape({
        width: PropTypes.number,
        slidesToShow: PropTypes.number,
    })),
    initialSlide: PropTypes.number,
    showArrows: PropTypes.bool,
    arrows: PropTypes.any,
    showDots: PropTypes.bool,
    dots: PropTypes.any,
    align: PropTypes.string,
    infinite: PropTypes.bool,
    showTransparent: PropTypes.bool,
    scrollByShow: PropTypes.bool,
    autoplay: PropTypes.bool,
    vertical: PropTypes.bool,
    autoplaySpeed: PropTypes.number,
    autoplayDelay: PropTypes.number,
    arrowsConfig: PropTypes.shape({
        width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        distance: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    overwriteStyles: PropTypes.shape({
        slide: PropTypes.object,
        track: PropTypes.object,
    }),
};

Carousel.defaultProps = {
    slidesToShow: slidesToShow_DEFAULT,
    responsive: null,
    initialSlide: 0,
    showArrows: true,
    arrows: DefaultArrows,
    showDots: true,
    dots: DefaultDots,
    align: 'left',
    infinite: false,
    showTransparent: false,
    scrollByShow: false,
    autoplay: false,
    vertical: false,
    autoplaySpeed: AUTOPLAY_SPEED,
    autoplayDelay: AUTOPLAY_DELAY,
    changeCallback: null,
    arrowsConfig: {},
};

export default Carousel;
